import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsNutritionEntriesDivider = () => {
  return <View style={styles.divider} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.LIGHT,
  },
});
